import { CommentDocument } from '@/domain/types/collections';
import { useState } from 'react';
import { FiTrash } from 'react-icons/fi';
import Button from '../../button';

const formatName = (raw: string): string =>
  raw
    .split(' ')
    .filter((w) => w && w.toLowerCase() !== 'undefined')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ') || '—';

const CommentsDetailDocument = ({
  data,
  deleteComment,
}: {
  data: CommentDocument[];
  deleteComment: (id: string) => void;
}) => {
  const [commentToDelete, setCommentToDelete] = useState<string | null>(null);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleDelete = () => {
    if (commentToDelete) {
      deleteComment(commentToDelete);
      setCommentToDelete(null);
      setIsConfirmOpen(false);
    }
  };

  return (
    <div className="bg-white rounded-lg p-4 shadow-md flex flex-1 flex-col gap-4">
      <div className="flex flex-col gap-4">
        <span className="text-sm text-gray-500">Comentarios</span>
        <div className="flex flex-col gap-4">
          {data
            ?.filter((comment) => !comment.isUserBlocked)
            .map((comment) => (
              <div
                key={comment.id}
                className="flex flex-col gap-2 border-b border-gray-200 pb-4"
              >
                <div className="flex flex-row justify-between items-center">
                  <div className="flex flex-col gap-2">
                    <span className="text-sm font-bold">{formatName(comment.name ?? '')}</span>
                    <span className="text-sm text-gray-500">
                      {comment.comment}
                    </span>
                  </div>
                  <Button
                    variant="ghost"
                    label=""
                    onClick={() => {
                      setCommentToDelete(comment.id);
                      setIsConfirmOpen(true);
                    }}
                    icon={<FiTrash className="w-4 h-4" />}
                    className="w-fit"
                  />
                </div>
              </div>
            ))}
        </div>
      </div>
      {/* Modal de confirmación */}
      {isConfirmOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
          <div className="bg-white p-6 rounded shadow-md flex flex-col gap-4 min-w-[300px]">
            <span className="text-lg font-semibold">Eliminar comentario</span>
            <span className="text-sm">
              ¿Estás seguro de que deseas eliminar este comentario?
            </span>
            <div className="flex gap-2 justify-end">
              <Button
                variant="secondary"
                label="Cancelar"
                onClick={() => {
                  setIsConfirmOpen(false);
                  setCommentToDelete(null);
                }}
              />
              <Button
                variant="danger"
                label="Eliminar"
                onClick={handleDelete}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CommentsDetailDocument;
